export const ADMIN = {
    state: {
        isPointCloudsDeleted: false,
    },
    mutations: {
        SET_IS_POINT_CLOUDS_DELETED(state, value) {
            state.isPointCloudsDeleted = value;
        },
    },
    getters: {
        GET_IS_POINT_CLOUDS_DELETED(state) {
            return state.isPointCloudsDeleted;
        },
    },
    actions: {
        SET_IS_POINT_CLOUDS_DELETED(context, value) {
            context.commit('SET_IS_POINT_CLOUDS_DELETED', value);
        },
    },
    namespaced: true,
}